<template>
  <v-app>
    <v-main class="auth-pages">
      <splash-showcase
        v-if="!context_loaded && !skipSplash"
        :loop="false"
      ></splash-showcase>

      <v-container v-else-if="!context_loaded" fluid fill-height>
        <v-layout class="align-center justify-center">
          <v-progress-circular
            :indeterminate="true"
            :rotate="20"
            :size="92"
            :width="8"
            color="#3A416F"
          ></v-progress-circular>
        </v-layout>
      </v-container>

      <div v-if="context_loaded">
        <div
          class="header-auth position-relative ma-4 pb-8 pt-8 border-radius-xl"
          :style="`  background-image:  url(${require('@/../../shared/app/assets/img/login_background.png')}; background-size: cover; background-position:center; `"
        >
          <v-container>
            <v-row class="pt-8 d-flex mt-10">
              <v-col class="text-center">
                <v-img
                  class="mx-auto"
                  max-width="256"
                  max-height="256"
                  :src="require('@/../../shared/app/assets/logo.png')"
              /></v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6" class="mx-auto py-0 position-relative">
                <h3
                  class="text-h3 font-weight-bold text-white text-center mb-2"
                >
                  {{ headerTitle() }}
                </h3>

                <p
                  class="text-black font-size-root text-center text-h6 text-typo font-weight-light mb-12"
                >
                  {{ paragraphs }}
                </p>
              </v-col>
            </v-row>
          </v-container>
        </div>
        <unauth-app-bar background="transparent" has-bg linkColor="white">
        </unauth-app-bar>
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <v-container class="mt-n16 pb-0">
            <router-view></router-view>
            <unauth-content-footer
              auth
              v-if="!$route.meta.hideFooter"
            ></unauth-content-footer>
          </v-container>
        </fade-transition>
      </div>
    </v-main>
  </v-app>
</template>
<script>
import UnauthAppBar from "@/components/mockup/UnauthAppBar";
import { FadeTransition } from "vue2-transitions";
import UnauthContentFooter from "@/components/mockup/UnauthFooter.vue";
import SplashShowcase from "@/views/framework/SplashShowcase.vue";

import context from "@/apis/context";

export default {
  name: "page-layout",
  components: {
    UnauthAppBar,
    FadeTransition,
    UnauthContentFooter,
    SplashShowcase,
  },
  data() {
    return {
      paragraphs: "",
      tab: null,
      context_loaded: false,
      skipSplash: false,
      splashStartedAt: 0,
      revealTimeoutId: null,
    };
  },

  mounted() {
    this.skipSplash =
      sessionStorage.getItem("skip-loader-splash-once") === "1";
    sessionStorage.removeItem("skip-loader-splash-once");

    this.context_loaded = false;
    this.splashStartedAt = Date.now();
    context
      .fetchContext()
      .then((res) => {
        this.$store.state.storeContextAndIdentity(res.context, res.identity);
        this.revealAfterAnimation();
      })
      .catch((err) => {
        console.log(err);
        this.revealAfterAnimation();
      });
  },

  beforeDestroy() {
    if (this.revealTimeoutId) {
      clearTimeout(this.revealTimeoutId);
      this.revealTimeoutId = null;
    }
  },

  computed: {
    logoImage() {
      return "data:image/png;base64," + this.$store.state.identity.logo_file;
    },
  },

  methods: {
    revealAfterAnimation() {
      if (this.revealTimeoutId) return;

      if (this.skipSplash) {
        this.context_loaded = true;
        return;
      }

      const splashDurationMs = 4200;
      const postAnimationDelayMs = 1000;
      const elapsedMs = Date.now() - this.splashStartedAt;
      const waitMs =
        elapsedMs < splashDurationMs
          ? splashDurationMs - elapsedMs + postAnimationDelayMs
          : postAnimationDelayMs;

      this.revealTimeoutId = setTimeout(() => {
        this.context_loaded = true;
        this.revealTimeoutId = null;
      }, waitMs);
    },

    headerTitle() {
      switch (this.$route.name) {
        case "Login":
          this.paragraphs = this.$t("labstream-system-reserved", {
            company: this.$store.state.identity
              ? this.$store.state.identity.name
              : "",
          });
          break;
        default:
          break;
      }
    },
  },
};
</script>
